import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LocalDataSource } from 'angular2-smart-table';
import { combineLatest } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { OfbizFormsService } from '../ofbiz-forms.service';
import { SmartTableDatePickerComponent } from '../smart-table-date-picker/smart-table-date-picker.component'

@Component({
  selector: 'ubs-ofbiz-view-list',
  templateUrl: './ofbiz-view-list.component.html',
  styleUrls: ['./ofbiz-view-list.component.scss']
})
export class OfbizViewListComponent implements OnInit, OnDestroy {
  @Input() value:any;
  @Input() componentConfig:any;
  @Input() options:any;

  idField:string;
  idValue:string;
  target:string;

  findForm = this.fb.group({});
  listSize:number;

  //Smart-table options
  settings:any = {
    hideSubHeader: true,
    mode:'inline',
    add: {
      addButtonContent: '<i class="nb-plus table-action"></i>',
      createButtonContent: '<i class="nb-checkmark table-action"></i>',
      cancelButtonContent: '<i class="nb-close table-action"></i>',
    },
    edit: {
      editButtonContent: '<i class="nb-edit table-action"></i>',
      saveButtonContent: '<i class="nb-checkmark table-action"></i>',
      cancelButtonContent: '<i class="nb-close table-action"></i>',
    },
    delete: {
      deleteButtonContent: '<i class="nb-trash table-action"></i>',
      confirmDelete: true,
    },
    pager:{
      perPage:50
    },
    actions:{
      position:"right",
      /* custom:[
        {
          name:'linkedList',
          title:'<i class="nb-list" title="Linked List"></i>'
        }
      ], */
      //add:true
    }
  }

  source: LocalDataSource = new LocalDataSource();
  loaded = false;
  columnsSet = false;
  hasLinkedList = false;

  alive = true;
  
  constructor(private fb: FormBuilder,private ofbizFormService:OfbizFormsService) { }

  ngOnInit(): void {
    console.log("in OfbizViewListComponent");
    this.idField = this.componentConfig["idFieldName"];
    this.idValue = this.value[this.idField];
    this.target = this.options["target"];
    this.findForm.addControl(this.idField,new FormControl(this.idValue));
    this.findForm.addControl('noConditionFind',new FormControl('Y'));
    this.findForm.addControl('formName',new FormControl(this.options["formName"]));
    this.findForm.addControl('formLocation',new FormControl(this.options["formLocation"]));
    this.findForm.addControl('entityName',new FormControl(this.options["entityName"]));
    let remoteFormData = {
      formData:{
        formName:this.options["formName"],
        formLocation:this.options["formLocation"]
      },
      endPoint:""
    }
    combineLatest([
      this.ofbizFormService.getForm({formName:this.options["formName"],entityName:this.options["entityName"],formLocation:this.options["formLocation"]}),
      this.ofbizFormService.getList(remoteFormData)
    ])
    .pipe(takeWhile(() => this.alive))
    .subscribe(([formData,listData]) => {
      console.log(listData);
      let fields = formData["fields"];
      if(fields){
        console.log(fields);
        this.settings["columns"] = this.createColumns(fields);
        if(listData["responseMessage"] == "success"){
          this.listSize = +listData["listSize"];
          if(this.listSize > 0){
            console.log(listData["list"]);
            this.source.load(listData["list"]);
            this.loaded = true;
          }
        }
      }
      
    })

    /* this.ofbizFormService.getForm({formName:this.options["formName"],entityName:this.options["entityName"],formLocation:this.options["formLocation"]})
    .subscribe(data => {
      console.log(data);
      let fields = data["fields"];
      if(fields){
        this.settings["colums"] = this.createColumns(fields);
        this.columnsSet = true;
      }
    });      
    this.ofbizFormService.getList(this.findForm.value,this.target)
    .subscribe(data => {
      if(data["responseMessage"] === "success"){
        this.listSize =+data["listSize"];
        if(this.listSize > 0){
          this.source.load(data["list"]);
          this.loaded = true;
        }
      }
    }) */
    /* this.ofbizFormService.getForm(this.options)
    .subscribe(data => {
      console.log(data);
    }) */
  }

  createColumns(fields:any[]){
    let columns = {};
    let hiddedFields = ["submit","hidden","hyperlink"]
    fields.forEach(field => {
      if(!hiddedFields.includes(field.type)){
        columns[field.name] = {
          "title":field.title,
          "type":this.getType(field),
          "editable":this.getEditable(field),
          "editor":this.getEditor(field),
          filter:false,
          sort:true
        }
      }
      
    });
    return columns;
  }

  getEditor(field):any{
    let editor = {};
    if(field["type"] == "datetime"){
      editor = {"type":"custom","component":SmartTableDatePickerComponent}
    }
    return editor;
  }

  getType(field):string{
    let type = "text";
    if(field["type"] == "datetime"){
      type = "html";
    }
    return type
  }

  getEditable(field):boolean{
    console.log({"type":field.type});
    let editable = false;
    if(field.type != "display" && field.type != "text" && field.type != undefined){
      editable = true
    }
    return editable;
  }

  ngOnDestroy(): void {
    this.alive = false;
  }

}
